import { Map } from 'immutable';
import { selector } from '@/lib/selectors';
import { categoriesListSelector } from '@/domain/categories/categoriesLeafSelectors';
import { createTreeFromNestedSet, getRootItems, getCategoryAll, getCategoryInbox } from '@/domain/categories/helpers';

export { categoriesListSelector };

// DA-19682 / da-19295 D10: flat lookup { tabCategoryId -> name_id } over every category's `tabs`.
// The active document type is derived from the URL by matching its deepest category segment here:
// the segment resolves to 'all' (the category's own id), 'financial', 'general', or undefined
// (a tab-less category). Powers in-session document-type persistence with no extra request.
export const doctypeTabLookupSelector = selector(categoriesListSelector, (list) =>
  list.reduce((acc, cat) => (cat.tabs || []).reduce((m, tab) => m.set(String(tab.id), tab.name_id), acc), Map()),
);

export const rootCategoriesListSelector = selector(categoriesListSelector, getRootItems);

// exposes tree categories structure instead of flat
export const categoriesTreeSelector = selector(categoriesListSelector, createTreeFromNestedSet);

export const categoryAllSelector = selector(rootCategoriesListSelector, getCategoryAll);

export const categoryInboxSelector = selector(rootCategoriesListSelector, getCategoryInbox);
